const config = {
	title: '华海后台管理',
	abbreviation: '华海',

}
export default config
